module.exports = __webpack_public_path__ + "img/platform.1be0a883.jpg";